<template>

  <div>
    <div class="form-group">
      <div class="form-group">
        <label class="control-label">* {{  $t('Expires in')  }}</label>
        <date 
          :setting="{format: 'DD-MM-YYYY'}"
          v-model="value.expired_at">
          </date>
        <ValidateMessage :error="validateErrors.expired_at" />
      </div>

      <label for="exampleFormControlInput1">{{ $t('Show') }}</label>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.contact">
        <label class="form-check-label">
          {{ $t('Contact information') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.salary">
        <label class="form-check-label">
          {{ $t('Salary') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.resume">
        <label class="form-check-label">
          {{ $t('Resume (file)') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.evaluations">
        <label class="form-check-label">
          {{ $t('Evaluations') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.intervideos">
        <label class="form-check-label">
          {{ $t('Video interview') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.questionnaires">
        <label class="form-check-label">
          {{ $t('Questionnaires') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.candidate_attachs">
        <label class="form-check-label">
          {{ $t('Attachs') }}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="value.permissions.add_evaluation">
        <label class="form-check-label">
          {{ $t('Allow evaluation') }}
        </label>
      </div>
      
      <div v-if="!value._id">
        <hr>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="value.send_email">
          <label class="form-check-label">
            {{ $t('Send email') }}
          </label>
        </div>
        
        <div v-if="value.send_email">
          <br>
          <div>
            <selectize-email v-model="value.to" :options="emailOptions"></selectize-email>
            <ValidateMessage :error="validateErrors['to.email']" />
          </div>
          <div>
            <textarea-autosize
              :placeholder="$t('Message')"
              v-model="value.body"
              :min-height="30"
              :max-height="350"
              class="form-control">
              </textarea-autosize>
            <ValidateMessage :error="validateErrors.body" />
          </div>
        </div>
        
      </div>

    </div>

    <div :class="{'box-loading': loading}">
      <button
        type="submit"
        class="btn btn-primary"
        @click="saveShare(value)">{{ $t('Share') }}</button>
      <button
        v-if="value._id"
        type="submit"
        class="btn btn-light"
        @click="$emit('cancel')">{{ $t('Cancel') }}</button>
    </div>
  </div>

</template>

<script>
import Date from '@/components/Fields/Date'
import SelectizeEmail from '@/components/Fields/SelectizeEmail'
import moment from 'moment'

export default {
  name: 'CandidateShareForm',
  components: {
    Date,
    SelectizeEmail
  },
  props: [
    'initValue'
  ],
  data () {
    return {
      validateErrors: false,
      loading: false,
      value: this.defaultValues(this.initValue)
    }
  },
  computed: {
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    emailOptions () {
      return [{
        name: this.selectedJob.hiring_manager_name,
        email: this.selectedJob.hiring_manager_email
      }]
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        expired_at: moment().add(1, 'month').startOf('day').toISOString(),
        permissions: {
          evaluations: true
        }
      }, values)
    },
    /*
    saveShare
    */
    saveShare (data) {
      if (data._id) this.updateShare(data)
      else this.createShare(data)
    },
    /*
    resetShare
    */
    resetShare () {
      this.value = {
        expired_at: this.value.expired_at,
        permissions: this.value.permissions
      }
      this.validateErrors = false
    },
    /*
    createShare
    */
    createShare (data) {
      this.loading = true

      data.candidates = [this.candidate._id]
      data.job_id = this.selectedJob._id

      this.$store
      .dispatch('createShareCandidate', data)
      .then((result) => {
        this.loading = false
        this.resetShare()
        this.$emit('created', result)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateShare
    */
    updateShare (data) {
      this.loading = true

      this.$store
      .dispatch('updateShareCandidate', data)
      .then((result) => {
        this.loading = false
        this.$emit('updated', result)
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Share/CandidateShareForm.vue